import translating from './translate.json';

export const tableHeadersClients = [
  translating.clientId,
  translating.fullName,
  translating.ssn,
  translating.orgRelated,
  translating.phone,
  translating.address,
  translating.email,
  translating.dateRegister,
  translating.type,
  translating.status,
  translating.allowEmails
];

export const columnsClients = [
  { value: 'id' },
  { value: 'full_name', sort: true, bold: true },
  { value: 'ssn', sort: true },
  { value: 'organization', subField: 'name', sort: true },
  { value: 'mobile', bold: true },
  { value: 'address' },
  { value: 'email', bold: true },
  { value: 'createdAt', format: 'date', sort: true },
  { value: 'client_type' },
  { value: 'isActive', sort: true, format: 'status' },
  { value: 'allow_rceive_emails', sort: true, format: 'status' }
];
